let fallbackSequence = 0;

function fallbackUuid() {
    const timestamp = Date.now().toString(16).padStart(12, "0");
    const highResolutionTime = Math.trunc((globalThis.performance?.now?.() ?? 0) * 1000)
        .toString(16)
        .padStart(12, "0");
    const sequence = (fallbackSequence++).toString(16).padStart(8, "0");
    const hex = `${timestamp}${highResolutionTime}${sequence}`.padEnd(32, "0").slice(0, 32);
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-4${hex.slice(13, 16)}-8${hex.slice(17, 20)}-${hex.slice(20)}`;
}

export function generateUuid() {
    const cryptoApi = globalThis.crypto;
    if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
    if (!cryptoApi?.getRandomValues) return fallbackUuid();

    const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, "0"));
    return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
}

export function generateClientId(prefix) {
    return `${prefix}-${Date.now()}-${generateUuid()}`;
}
